export enum ETLCodes {
  SearchCriteriaPanel_SearchModes_GreaterThanOrEquals,
  SearchCriteriaPanel_SearchModes_LessThanOrEquals,
  SearchCriteriaPanel_Yes,
  SearchCriteriaPanel_No,
  SearchCriteriaPanel_SearchModes_Greater,
  SearchCriteriaPanel_SearchModes_GreaterOrEquals,
  SearchCriteriaPanel_SearchModes_Less,
  SearchCriteriaPanel_SearchModes_LessOrEquals,
  SearchCriteriaPanel_RemoveAll,
  SearchCriteriaPanel_ReturnDefault,
  SearchPlaceholder,
  Home,
  RouteConfirmDialogTitle,
  SaveSuccess,
  Login_UserNameIsRequired,
  Login_PasswordIsRequired,
  General_UserName,
  General_Password,
  Error_BackendNotRecheable,
  Login,
  Error,
  DeleteSuccess,
  DeleteConfirmationMessage,
  DeleteDialogTitle,
  General_Add,
  TableResults,
  General_TableCriterias,
  QuickAccess,
  UnFixMenuTooltip,
  FixMenuTooltip,
  Menu,
  Logout,
  FormDirtyRouteChangeMessage,
  General_No,
  General_Yes,
  General_View,
  SendAnSMS,
  General_Save,
  General_Edit,
  General_Copy,
  General_GoBack,
  Search,
  General_Delete,
  Retour,
  Referential,
  Race,
  Age,
  PaysOrigine,
  IsoCode,
  Prefix,
  Pays,
  Chien,
  Breed,
  OfficialName,
  BreedGroupLabel,
  NameNL,
  NameFR,
  NameEN,
  Error_Login,
  BreedGroups,
  Dog,
  ActiveBreedsGroups,
  Breeds,
  Required,
  RequiredDate,
  InvalidDate,
  Libelle,
  New,
  Detail,
  ColorCode,
  Official,
  ReplacedBy,
  Colors,
  SearchCriteriaPanel_SearchModes_StartWith,
  SearchCriteriaPanel_SearchModes_EndWith,
  SearchCriteriaPanel_SearchModes_Contains,
  SearchCriteriaPanel_SearchModes_NotContains,
  SearchCriteriaPanel_SearchModes_Equals,
  SearchCriteriaPanel_Search,
  NameEn,
  Code,
  Active,
  LinkedBreeds,
  LinkedColors,
  IsMerle,
  Country,
  AS400Mapping,
  PedigreePrefix,
  DefaultCountry,
  Initiales,
  Kennel,
  Type,
  Name,
  Sport,
  WorkbookTypes,
  RecognizedColor,
  Color,
  HasPedigree,
  Description,
  Sufix,
  WorkbookType,
  General_Modify,
  BreedName,
  RefusedColors,
  Judges,
  Health,
  BreedCompatibility,
  Clubs,
  Owners,
  Dogs,
  FirstName,
  ChipNumber,
  LastName,
  Language,
  Email,
  PhoneNumber,
  MobilePhoneNumber,
  Pedigree,
  ColorForBreed,
  Identification1,
  Identification2,
  Pedigrees,
  LinkedFiles,
  Genealogy,
  Titles,
  TitleName,
  TitleType,
  Year,
  Number,
  OpeningDate,
  Contact,
  PedigreeNo,
  Resultat,
  General_Cancel,
  OwnerFrom,
  OwnerTo,
  CompleteName,
  BirthDate,
  Sex,
  CompletePedigree,
  Mother,
  Father,
  Modify,
  Dashboard,
  Abreviation,
  Sections,
  CalendarYear,
  NamingLetter,
  PaymentLimit,
  Section,
  Activity,
  Activities,
  SubActivities,
  AllowedBreeds,
  OfficialColor,
  Historique,
  Contest,
  Address,
  VATNumber,
  AccountNumber,
  PostalCode,
  Street,
  City,
  File,
  DogActionHistory,
  BreedGroupActionHistory,
  ActionHistoryBreedGroup,
  ActionHistoryDog,
  Role,
  People,
  Breeders,
  Translations,
  TranslationCode,
  LanguageCode,
  Text,
  Workbook,
  Counter,
  Identifier,
  WithPedigree,
  DeliveredOn,
  UnknownMother,
  UnknownFather,
  Export,
  Import,
  GoToSharePoint,
  SharePoint,
  AwaitingValidation,
  ReceivedDNA,
  DeathDate,
  Remark,
  Breeder,
  DockedTail,
  InternalNumber,
  Other,
  BreedNameEN,
  BreedNameFR,
  SocialBehaviour,
  Competition,
  BreedingAdmission,
  WorkCertificate,
  AmountTries,
  ExclusionReason,
  ExclusionEndDate,
  ExclusionStartDate,
  BreedNameNL,
  KnownBreed,
  AddPedigree,
  AddOwner,
  AttributionDate,
  ClosingDate,
  Agility,
  Grooming,
  SubjectToWork,
  StandardConfirmation,
  FromCombinaison,
  ShortenedTail,
  MerleColorAuthorized,
  Size,
  FileAffix,
  PublishingDate,
  CountryOfOrigin,
  Exclusion,
  Exception,
  Varieties,
  ClubRoles,
  ClubRoleNameNL,
  GlobalEmail,
  WebsiteAdresse,
  ProvisionalNumber,
  ProvisionalNumberDate,
  FinalNumberDate,
  FinalNumber,
  Addresses,
  HasLinkedBreed,
  Owner,
  Status,
  RequestDate,
  LinkedBroodFiles,
  RequestNumber,
  FciNumber,
  Jury,
  TerrainAddress,
  Province,
  SelectContact,
  SelectorAvailable,
  SelectorSelected,
  SelectSection,
  RequestState,
  RequestType,
  PedigreeSelection,
  OwnerSelection,
  Club,
  BreedGroupNumber,
  OwnerSelected,
  WorkbookColor,
  IsoAS400,
  Canine,
  SelectColor,
  PedigreePrefixes,
  InvalidEmail,
  AuthorizedBreeding,
  NotValidPostalCode,
  JudgeEmail,
  WorkbookEmail,
  Color1,
  Color2,
  RefusedColorsSelection,
  Results,
  Result,
  Title,
  Next,
  TitleSelection,
  CanGiveWorkCertificate,
  SectionSelection,
  Workbooks,
  Characteristic,
  Value,
  DateFrom,
  DateTo,
  Dysplasia,
  Characteristics,
  ErrorWhileImportingTranslations,
  TestType,
  HealthTests,
  CharacteristicType,
  Laboratory,
  FiliationControlled,
  FiliationCorrect,
  Value2,
  Value1,
  Marker,
  DnaMarkers,
  DnaTest,
  NotValidCharacteristicCode,
  TitleTypes,
  TableResults_Plural,
  YearAlreadyExists,
  ActionHistoryPerson,
  CharacteristicValues,
  IsoCodeAlreadyExists,
  SizeFrom,
  SizeTo,
  Countries,
  Kennels,
  CalendarYears,
  BreedGroupNumberAlreadyExists,
  WorkbookTypeAlreadyExists,
  CodeAlreadyExists,
  CompetitionDate,
  WithoutPedigree,
  ChooseXItems,
  UnChooseXItems,
  GeneralNoData,
  Select,
  LoginButton,
  Contacts,
  StreetNumber,
  MustBeANumber,
  ContactEmails,
  MustBeValidSeparatedEmail,
  SaveBreederConfirmation,
  SaveDialogTitle,
  BreederSelection,
  CharacteristicAndValueAlreadyExistsForDog,
  PedigreePrefixSelection,
  BreedVariety,
  BreedVarieties,
  BreedExceptions,
  BreedExceptionSelection,
  BreedException,
  BreedVarietySelection,
  Competitions,
  PedigreeExistsError,
  OwnerDateMustBeAfterDogBirthDate,
  IsAptForBeauty,
  IsAptForWork,
  Judge,
  IsBadPayer,
  BannedFrom,
  BannedTo,
  Salutation,
  EmailIsAlreadyInUse,
  AddAll,
  AddAllText,
  AddElementText,
  RemoveAll,
  RemoveAllText,
  RemoveElementText,
  IsCAMember,
  IsCEMember,
  IsCynologicCouncilMember,
  IsFCIDelegateMember,
  IsVDA,
  IsSupervisor,
  IsVolunteer,
  Membership,
  MemberFrom,
  MemberTo,
  MembershipHistory,
  WebUser,
  ResetPassword,
  ResetPasswordMessage,
  ResetPasswordTitle,
  MembershipDateExistsError,
  MemberToDateError,
  MembershipType,
  IsVet,
  VeterinaryNumber,
  IBAN,
  Veterinary,
  Request,
  Requests,
  ParentRequest,
  ForSelecion,
  WorkRequests,
  RSH,
  RISHRequests,
  TitleRequests,
  CloseRequestConfirmationMessage,
  CloseRequests,
  FilesClosedSuccess,
  CloseRequestSelectionEmpty,
  General_Ok,
  Clinic,
  HK,
  firmNameInvoicing,
  DogWorkbookWarning,
  PedigreeDuplicataRequests,
  Person,
  ActionHistoryClinic,
  AuthorizedVeterinary,
  PedigreeDuplicataRequest,
  History,
  Billing,
  SubRequests,
  Conditions,
  Verifications,
  MustBeOwnerOrBreeder,
  IsNotDogOwnerOrBreederMessage,
  Warning,
  KennelOwnershipHistory,
  Change,
  LockUnlock,
  RePrint,
  ClinicSelection,
  Clinics,
  DogOwnershipChangeRequest,
  MustBeValidHkNumber,
  MustBeValidIbanNumber,
  DogOwnershipChangeRequests,
  WorkJudgeEmail,
  TitleRequest,
  Date,
  YearMustBeBetweenBirthAndDeathError,
  OldOwnerAccord,
  PedigreeReceived,
  VerificationsToObtainBilledStatus,
  Ask,
  ShowAlive,
  HasSocialibilityTest,
  CanBeOwnerOrOtherPersonInformation,
  OwnerMustHaveAddressInBelgium,
  AllRequests,
  IsNotBelgianOwner,
  PrefixAlreadyExists,
  RISHRequest,
  Veterinarians,
  YearIsNotCorrect,
  MustBeValidDateUntilToday,
  Confirm,
  LinkedRequests,
  RequestAffix,
  LinkedBroodRequests,
  RequestsClosedSuccess,
  CancelRequestConfirmationMessage,
  CancelRequest,
  BreedSelection,
  MailAddress,
  WorkbookRequests,
  PaymentConfirmationMessage,
  PaymentStatusRequest,
  JudgeType,
  JudgeDateInternship,
  JudgeDateExcludedFrom,
  JudgeDateNomination,
  JudgeDateExcludedTo,
  SubActivity,
  SubActivitySelection,
  HideDead,
  Unblock,
  Block,
  WorkRequired,
  ActionHistoryPedigreeDuplicataRequest,
  ActionHistoryRish,
  ActionHistoryTitleRequest,
  ActionHistoryRsh,
  DogHasAnotherRequestError,
  PleaseSelectADogToEditOwners,
  DogInformations,
  PedigreeInformation,
  ParentInformations,
  OtherInformations,
  DogIsDeceased,
  ActionHistoryWorkbookRequest,
  WorkbookRequest,
  PleaseSelectDogToAddWorkbooks,
  WorkAttestationRequest,
  Points,
  Anyone,
  ActionHistoryWorkAttestationRequest,
  CompetitionCountry,
  ResultCopy,
  WorkbookCopy,
  CanineResponse,
  NewOwnerAccord,
  Force,
  MissingInformation,
  ConditionsForBillingStatus,
  Tatoo,
  Forced,
  DogIsNotBelgianWithPedigree,
  DogAlreadyHasTitle,
  ForceConditionConfirmationMessage,
  ForceCoditionConfirmationTitle,
  ConditionForcedsuccessfully,
  WorkAttestationRequests,
  DateMustBeGreaterThanBirthDate,
  DogMustBeExpoOrWithoutPedigree,
  DogIsNotBelgianOrImportOrForeignOrWithoutPedigree,
  AddSubFile,
  MustBeOldOrNewOwnerOrAnyone,
  IsAMember,
  IsNotAMember,
  DogHasNoCurrentOwner,
  DogIsNotBelgianOrImport,
  CreateEmptyVet,
  BreedNumber,
  BreedKownDate,
  Internship,
  InternshipDate,
  RequestBlocked,
  TemporaryOwner,
  Administration,
  Users,
  Profile,
  CanBeAnyone,
  BreedingAuthorized,
  DogNotExcludedCondition,
  DogAllowedForReproduction,
  TemporaryOwnerCondition,
  DogsSelectFather,
  DogsSelectMother,
  ResetPasswordDialogTitle,
  ResetPasswordDialogMessage,
  PasswordResetSuccess,
  Login_EmailIsRequired,
  NewPasswordEmailSent,
  UnknownEmail,
  PasswordChangeTitle,
  ForgottenPassword,
  PasswordMustMatch,
  PasswordChanged,
  PasswordValidation,
  Departments,
  ImportRequest,
  ImportRequests,
  DogIsNotImport,
  AtLeastOneOwnerIsNotBelgian,
  DogIsImport,
  NotAuthorized,
  ReferToAdminOrRelogin,
  Permission,
  Module,
  Tab,
  None,
  Read,
  ReadWrite,
  ReadWriteDelete,
  Execute,
  TemporaryOwnerFrom,
  TemporaryOwnerTo,
  TempRSHRequest,
  TempRSHRequests,
  NotAllVerificationsChecked,
  VerificationMessage,
  Manager,
  UnassignedRequests,
  Assign,
  Compatibility,
  DogUpdate,
  MyTasks,
  AssignedRequests,
  ForeignTitlesToAssign,
  ForeignTitlesToAValidate,
  Validate,
  HealthCharacteristicsToAssign,
  HealthCharacteristicsToValidate,
  AssignElementsQuestion,
  ValidateElementsQuestion,
  SelectionEmpty,
  ActionHistoryUser,
  OwnerIsTemporaryError,
  ForgottenPasswordTitle,
  ExecuteConfirmationMessage,
  ExecuteConfirmationTitle,
  DateInThePastError,
  DogAlreadyHasImportPedigree,
  When,
  Who,
  What,
  OwnerHasTemporarilyCeaded,
  TitleInformation,
  NoVerifications,
  NextValue,
  OwnerIsNotBelgian,
  ExceedsAllowedTime,
  DateMustBeGreaterThanOwnerTo,
  DateTooSmall,
  DateTooBig,
  ChangeNotAllowed,
  DateBeforeRequestDate,
  ChipDate,
  DogChips,
  DogChipCreation,
  Articles,
  ArticleNumber,
  BCIdentifier,
  Price,
  SocietyName,
  InvalidVAT,
  EndOfRenewal,
  EndRenewalConfirmationMessage,
  EndRenewalConfirmationTitle,
  RenewalSuccessfullyDisabled,
  MembershipRequest,
  DysplasiaRequests,
  DysplasiaRequest,
  RequestInformation,
  Radio,
  Appeal,
  Position,
  RequestData,
  MembershipRequestType,
  MeetingResult,
  MeetingDate,
  MeetingDecision,
  FinalMembershipType,
  ContactWasNotAMember,
  FinalTypeMustBeDifferentFromInitialtype,
  DecisionNotPossibleForMembershipRequestType,
  ContactIsAlreadyAMember,
  PersonAllreadyHasMembershipRequest,
  ContactIsAlreadyRenewed,
  SelectAll,
  AppealRequest,
  AtLeastOneValueMustBeSelected,
  DysplasiaType,
  AtLeastOneAppealMustBeTicked,
  Member,
  MembershipRenewal,
  CreateRequests,
  RequestCreationSuccess,
  CreateRenewRequestsTitle,
  CreateRequestsMessage,
  EVAT_Price,
  MembershipRenewals,
  MembershipRequests,
  Dysplasias,
  Commissions,
  Appeals,
  IsRefused,
  OfficialRemark,
  Evaluations,
  DefinitiveSave,
  Commission,
  DefinitiveSaveWarning,
  TitleData,
  DontHaveRights,
  PersonISDeceased,
  PersonIsExcluded,
  DogIsExcluded,
  CompetitionRequests,
  CompetitionRequest,
  ClubEmail,
  PersonIsNotOfClub,
  CatalogReception,
  Extra,
  ClubAddress,
  OtherAddress,
  DateMustBeGreaterThanStartDate,
  DateMustBeSmallerThanEndDate,
  ParticipantsCount,
  RequestIsMissingInformation,
  OneOrMoreJudgeCannotJudgeThisSubActivity,
  PleaseSelectSubActivityToViewPossibleJudges,
  Class,
  Qualification,
  CatalogNumber,
  BreedConformity,
  BestOfBreed,
  BestOfSex,
  BestInShow,
  BestInGroup,
  BestVeteran,
  BestWorkDog,
  BestYouth,
  BestMinorPuppy,
  BestPuppy,
  BelgianWinner,
  BeneluxWinner,
  BeneluxYouthWinner,
  BeneluxVeteranWinner,
  EuropeanWinner,
  Crufts,
  Cac,
  CacReserve,
  Cacib,
  CacibReserve,
  Cacbl,
  CacblReserve,
  Cacgpo,
  CacgpoReserve,
  Caciag,
  CaciagReserve,
  Cacil,
  CacilReserve,
  Caciob,
  CaciobReserve,
  Cacit,
  CacitReserve,
  LastConnectionDate,
  DysplasiasRequests,
  IsNotBelgianOwnerError,
  ActionHistoryDysplasiaRequest,
  IsNotCurrentlyAMember,
  ColorNumber,
  SectionIsNotPartOfClubError,
  MustBeBelgianOwner,
  ClubIsExcluded,
  Divers,
  RSHRequestCannotBeSavedTemporaryREquestConflict,
  SaveRSHRequest,
  ExcelExport,
  IsNotDogOwner,
  ClubMatch,
  IsNotBelgian,
  AffixRequests,
  ActionHistoryAffix,
  PersonIsAlreadyKennelOwner,
  NameOffer1,
  Affix,
  NameOffer5,
  NameOffer4,
  NameOffer3,
  NameOffer2,
  AffixType,
  NewKennelRequest,
  FCIDecision,
  FinalName,
  BeautyJudgeEmail,
  ImportKennelRequest,
  NameOffer,
  IsNotKennelOwner,
  IsNotOwnedByContact,
  KennelisNotInBelgium,
  KennelOwnershipChange,
  AtLeastOneOwnerIsNotBelgianOrIsAlreadyAKennelOwner,
  FCIAffixes,
  FCIAffixesImport,
  FCIAffixesExport,
  NewKennel,
  KennelNameChangeRequest,
  KennelOwnershipChangeRequest,
  WeightFrom,
  WeightTo,
  VarietyNumber,
  VATNotCorrespondingToCountry,
  Closed,
  KennelExportRequest,
  Close,
  ImportSucessfull,
  PleaseImportFile,
  FinalType,
  Importable,
  Accepted,
  ReadExcelFile,
  AllRightNothingToSend,
  InfosSentByEmail,
  JudgeValidation,
  AuthorizedSubActivity,
  JudgesValidation,
  Packs,
  IsProgenus,
  Article,
  HealthPackGroup,
  ProgenusCode,
  Group,
  HealthPack,
  Chart,
  PleaseSelectAKennelToEditOwners,
  ChartSignatureHistoryAdd,
  MustBeGreaterThanDateTo,
  MustBeGreaterThanDateFrom,
  CommissionType,
  AutomaticCreation,
  ImportStatus,
  FGSelectInput_Loading,
  FGSelectInput_NoOptions,
  FGSelectInput_SelectAnItem,
  Lab,
  KennelOwners,
  LabPack,
  NewUser,
  EnterYourData,
  DrupalLoginTitle,
  DrupalLoginButton,
  RememberMyData,
  LaboMapping,
  OkForInheritance,
  SelectForImport,
  SelectedItemsContainErrors,
  JudgeConfirmationMessage,
  JudgeConfirmationTitle,
  Cynology,
  FilePondDragOrSelect,
  FileReadSuccessfully,
  CloseKennel,
  CloseKennelConfirmationMessage,
  CloseKennelConfirmationTitle,
  KennelClosed,
  PreviousKennel,
  Affixes,
  LabCode,
  AtLeastOnePersonIsAlreadyOwner,
  PreviousAffix,
  FinalAffix,
  HealthTestRequests,
  BroodRequests,
  ProtusionDate,
  NumberOfPuppies,
  ActionHistoryHealthTestRequest,
  LabStatus,
  WhiteTest,
  ActionHistoryBroodRequest,
  BabyDgoPublication,
  Puppies,
  Puppy,
  PotentialFathers,
  PleaseSelectDogToViewPossibleFathers,
  IsNotBelgium,
  ProtrusionDate,
  CreatePedigree,
  Deceased,
  CreateDogAndPedigreeConfirmationMessage,
  CreateDogAndPedigreeConfirmationTitle,
  PuppyDeceasedConfirmationMessage,
  PuppyDeceasedConfirmationTitle,
  OwnerApproval,
  PotentialFathersOwnerApprovals,
  DogValidation,
  PotentialFathersValidation,
  MotherValidation,
  NotAllDogValidationsChecked,
  KennelIsExcluded,
  ProtusionDateAndBirthDateMustBeBetween54And68Days,
  PersonIsOwnerOfExcludedKennel,
  IsoAs400,
  Filiation,
  DogStatus,
  AuthorizedBreed,
  IsBanned,
  JudgeIsBanned,
  Subject,
  HasNlContent,
  HasEnContent,
  HasFrContent,
  Emails,
  Body,
  MiscellaneousRequests,
  MiscellaneousRequest,
  LiveDogs,
  Chip,
  Action,
  Payment,
  SelectNeededInformation,
  RequestConfirmation,
  General_Next,
  RequestResume,
  General_Send,
  General_Pay,
  YourRequestNumberIs,
  FinishedRequests,
  CurrentRequests,
  NewRequest,
  PleaseSelectRequestType,
  AwaitingSRSHValidation,
  AddNewWorkbook,
  PaymentMethod,
  OgonePayment,
  CashPayment,
  StructuredCommunication,
  PaymentReceiptMessage,
  Bill,
  Diploma,
  DrupalTitleRequestInfo,
  BroodRequest,
  PuppiesAreBorn,
  PotentialFatherId,
  AddPotentialFather,
  PotentialFatherCostWarning,
  PaymentInformations,
  PersonIsNotOwner,
  ResultIdentifier,
  General_Split,
  General_Group,
  FuseSelectionError,
  SplitSelectionError,
  GentCommission,
  GentCommissions,
  Note,
  OtherMembersDecision,
  Remarks,
  Evaluation,
  ThereMustBe44DaysMaximumBetweenProtrusionAndRequestDate,
  AlreadyIsKennelOwner,
  PersonIsBannedConfirmMessage,
  HasCharacteristicValue,
  RadioDate,
  IsBeauty,
  IsSport,
  DateCannotBeFuture,
  MinDysplasiaAgeInMonths,
  NameDoesNotStartWithCalendarLetter,
  SharePointPdfAvailable,
  SplitPerson,
  NewPerson,
  Split,
  CreditNote,
  Quantity,
  CreditMemoConfirmationMessage,
  CreditMemoConfirmationTitle,
  PersonSplitDogsMessage,
  PersonSplitBCMessage,
  PersonSplitWebPortalMessage,
  WebAccess,
  PersonSplitRequestsMessage,
  Veterinarian,
  PersonSplitKennelsMessage,
  PersonSplitBreederDogsMessage,
  LinkToSplitPerson,
  LinkToNewPerson,
  EmailsCannotBeTheSame,
  MustBeUnique,
  Fusion,
  OwnerPhoneNumber,
  OwnerEmailAddress,
  PersonFusionDogsMessage,
  HasDogs,
  HasRequests,
  HasKennel,
  PortalAccount,
  PersonFusionPortalMessage,
  PersonFusionRequestsMessage,
  PersonFusionKennelErrorMessage,
  IsJudge,
  PersonFusionJudgeMessage,
  PersonFusionVetMessage,
  PleaseSelectCriteria,
  OfficialNameAlreadyExists,
  IsOwnerOfMoreThanOneKennel,
  DogIsExportedMessage,
  AppliedToDysplasia,
  AccountingTasks,
  Task,
  Invoice,
  SaveNav,
  BCSaveConfirmationMessage,
  PersonFusionMemberMessage,
  PersonFusionBreederDogsMessage,
  FuseSelectionDogError,
  DnaTests,
  DogFusionChipsAndOwnersInformation,
  DogFusionKennelsError,
  DogFusionRequestsInformation,
  DogFusionSportInformation,
  DogFusionWorkbooksInformation,
  DogFusionDysplasiaInformation,
  DeceasedDogs,
  HasTitlesAndCompetitions,
  HasWorkbooks,
  HasDysplasias,
  HasDnaTest,
  DogFusionDnaTestError,
  HealthValueType,
  CanBeUsed,
  PleaseSelectALab,
  NotApproved,
  Approved,
  Approval,
  DogListFilterPlaceholder,
  FciDocument,
  OneOrMoreOwnersNotBelgian,
  UploadWordFile,
  DocumentTemplates,
  RecipientInfo,
  Content,
  Printer,
  PaperDecoration,
  GoToDetail,
  BelgianBreeds,
  BelgianBreedParagraph,
  About,
  WhatToKnow,
  BreedInformationText,
  DownloadBreedDocument,
  Website,
  Chairman,
  Secretary,
  NoInformation,
  PLeaseSelectBreed,
  Availability,
  NoBabyDogForBreed,
  NumberOfAvailablePuppies,
  IsWork,
  MissingEmailAndOrPhoneNumber,
  ViewDogDetail,
  InvalidPostalCode,
  Global,
  DogFusion,
  PeopleFusion,
  ClubInfo,
  Administrators,
  GeneralSecretary,
  NewPotentialFather,
  AddNewPotentialFather,
  ChangePassword,
  ChangeEmail,
  OldPassword,
  NewPassword,
  NewPasswordConfirmation,
  IncorrectPassword,
  Parents,
  UndefinedFather,
  EmailsMustMatch,
  NewEmail,
  NewEmailConfirmation,
  CurrentEmail,
  BirthInformations,
  Refuse,
  HideClosed,
  CloseTaskConfirmation,
  TitleNotDisplayedBeforeValidation,
  CurrentTitleRequest,
  CreationDate,
  VatPercentage,
  NumericValue,
  MemberNumber,
  ShowFinished,
  SubTasks,
  Finished,
  Done,
  DogsUpdate,
  CloseDashboardTaskMessage,
  CloseDashboardTaskTitle,
  SelectOther,
  WebsiteAdresseFr,
  WebsiteAdresseNl,
  BroodRequestDeclaration,
  GestationDeclaration,
  PuppyData,
  AddPerson,
  DownloadBill,
  MissingCompleteAdressOrEmail,
  MissingPhoneNumber,
  AnalysisInProgress,
  IncompletePuppyAnalysisMessage,
  IncompletePuppyAnalysisTitle,
  NoFatherFound,
  IsCac,
  ConfirmSaveWillSendEmail,
  ChipNumberAlreadyInUse,
  PleaseSelectAtLeatOneWorkbook,
  CloseTaskQuestion,
  CreateNewDog,
  CreatingFather,
  DrupalGetUser,
  DrupalCheckAccount,
  DrupalErrorEmailDoesNotExist,
  DrupalErrorEmailMultipleMatch,
  DrupalErrorEmailAccountAlreadyExists,
  ContactUs,
  PleaseCheckAndCompleteInfo,
  FileRequired,
  JurySelection,
  CreateInSharepoint,
  OneOrMorPersonAlreadyOwnsAKennel,
  Files,
  FileName,
  DocumentType,
  ADNProfile,
  BreedingAdmissionFiles,
  Miscellaneous,
  PuppyPrice,
  PriceVatIncluded,
  IsNotOwnerOrBreeder,
  CreatedOn,
  PuppiesBirth,
  PleaseDontForgetToAddChipNumber,
  FatherNotFoundClickAdd,
  Max20Puppies,
  BroodAndBirthRequest,
  DogAlreadyHasBelgianOwners,
  NumberMustBeBetween1And20,
  Documents,
  AlreadyOwnerOfTheDog,
  AtLeastOneOwnerRequired,
  NewDog,
  hkNumber,
  DogNotFoundClickAdd,
  MoreThanOnePersonAssociatedWithEmail,
  NoPersonAssociatedWithEmail,
  SearchOwners,
  OwnerFound,
  DownloadDocument,
  WorkbookRequestOngoingForThisWorkbookType,
  AtLeastOnePotentialFatherMustBeChosen,
  IsBreeder,
  ResendBill,
  BillResendConfirmationMessage,
  EmailAlreadyInUse,
  SelectAtLeastOneAnalysisOrPack,
  DrupalCreateNewDog,
  DrupalCreateNewRequest,
  CreditMemo,
  IfDogNotOwnedContactSrsh,
  AddPersonAsPuppyOwner,
  AnotherOwnerToAddPortalMessage,
  RegisteredLetter,
  DuplicatePedigree,
  MailAdmin,
  Filter,
  WorkbookCreationOnlyAllowedForBelgianResitents,
  PuppyInformationIncomplete,
  ShowType,
  Print,
  EvaluationDate,
  ChangePasswordFailed,
  ErrorWhileSavingPassword,
  PasswordComplexityMessage,
  AS400Title,
  CertificateNotReceived,
  ClickHereIfDogDeceased,
  FciTax,
  ProgenusPuppy,
  PedigreesToReprint,
  ReprintFirst200,
  PrintSuccess,
  ReprintWorkbook,
  General_Price,
  Reports,
  GenerateReport,
  TurnOver,
  Month,
  ViewFile,
  NumberOfPuppiesConfirmed,
  PaidExport,
  BilledExport,
  InvalidateRequest,
  invalidatedOn,
  YouWantToInvalidateTheResultConfirmation,
  ContactPerson,
  DogIsMissingChipOrTattoo,
  AddDnaMarkers,
  WaloonWithoutHK,
  LoadMore,
  DogToAssign,
  DogToValidate,
  DogToUpdateAs400Title,
  PuppiesPictureMax3,
  FilePondDragOrSelectMax3Files,
  PuppyDockedTail,
  FilePondDragOrSelectMax3PuppiesPicture,
  DrupalErrorExistingUserButNoAccount,
  ParticipationFciTax,
  IsSticker,
  TypeHasNoDocument,
  ExportCountry,
  CompetitionResults,
  RegenDiploma,
  Success,
  ReprintExecutionLetter,
  ProgenusQuickDelivery,
  LinkedCompetition,
  OpenCompetition,
  InvalidFormData,
  RegenDysplasiaCertificate,
  DeleteAllDna,
  DeleteAllDnaConfirmationMessage,
  WithRequest,
  WithoutRequest,
  BreedNotFciRecognized,
  As400Pedigree,
  RegenDocuments,
  HealthProfile,
  RegenImportRequestDocuments,
  SwitchToLoshPedigrees,
  CompetitionFile,
  AtLeastOnOfTheTitlesAlreadyExists,
  Renewal,
  ReprintPedigrees,
  ShowOnPortal,
  HealthTestDocumentValidationToAssign,
  HealthTestDocumentValidationToValidate,
  TaskDone,
  WarningMustBeAliveInProgenus,
  Resurrect,
  NameAlreadyTaken,
  UnCancelRequest,
  RegenKennelApprovedDocument,
  ShouldDoubleResults,
  ImportStarted,
  ImportAlreadyInProgressPleaseWait,
  ImportWillStartYouWillReceiveAnEmailWhenFinished,
  Ok,
  IsImporting,
  CompetitionsWithoutResults,
  ResendPedigreeSample,
  confirmRegenAndResendPedigreeSample,
  PedigreeResendTitle,
  ResendPedigreeSampleDrupal,
  ExpatriationRequest,
  ActionHistoryExpatriationRequest,
  DogType,
  BelgianDog,
  ForeignDog,
  RemarkVisibleByVeterinaries,
  MembersReport,
  IsKnownPerson,
  CountryLanguages,
  Languages,
  Iso2LanguageCode,
  Iso2Code,
  BCLanguageCode,
  HasTranslation,
  SpokenLanguages,
  Commissioner,
  commissionerExperience,
  MyDogShowBilling,
  MyDogShowAuthorized,
  MyDogShowParameters,
  CompetitionManager,
  CallableRingManager,
  CallableJudges,
  Expos,
  ExpoName,
  AddExpo,
  WarningChangeCompetitionDatesAccordingly,
  NewDate,
  IsTablet,
  CompetitionName,
  ExpoStartHour,
  ComissionerArrivalTime,
  AllowedVolunteerProfiles,
  JudgeInformations,
  BreedJudgeToValidate,
  JudgeName,
  BreedGroup,
  DeleteJudgeTempBreed,
  CruftsQualification,
  MaxDurationTwoDays,
  IfDatesAreUpdatedAllConfiguredExpoWillBeLostDoYouWantToContinue,
  MyDogShow,
  MyDogShowActionRequired,
  IsCommissioner,
  PersonFusionCommissionerMessage,
  NotFatherSelected,
  Expo,
  ConfirmChange,
  PleaseExplainReason,
  MustBeInThePast,
  IncompleteGenealogy,
  BillGenealogyCompletion,
  BillFatherGenealogyCompletion,
  BillMotherGenealogyCompletion,
  IsRegisteredLetter,
  IfNotRegisteredLetterSrshIsNotResponsibleForAnyLostDocument,
  HDReport,
  ThisCharacteristicIsAwaitingValidationInDashboard,
  DeleteDnaProfile,
  DeleteDnaProfileConfirmationMessage,
  OpenBroodRequestExistsForThisDogDoYouStillWantTodeleteDnaProfile,
  FciRecognized,
  DnaTestIsag2006,
  DnaTestIsag2020,
  DnaTestIsag20,
  VerificationsToObtainDogValidationStatus,
  CoupleInbreeding,
  CreateInbreeding,
  Inbreeding,
  IsBrcsRequest,
  SrshPedigreeRequestedWarningWillBeBilled,
  SrshPedigreeConfirmed,
  HasFile,
  DogInbreedingConfirmation,
  FatherInbreeding,
  BRCSOnlyAvailableForFlemishBreeders,
  FlemishBreederDoYouWantToGoToFlemishPortal,
  ConfigureFatherInbreeding,
  ErrorNotAllFatherHaveInbreeding,
  Validated,
  Between0And100,
  BrcsPedigreeConfirmed,
}
